import React from 'react';

/**
 * 移动端底部可拖拽面板壳（拖拽条 + 内容区）
 */
export default function DashboardMobilePanelShell({
  containerRef,
  heightRatio,
  isDragging,
  onDragStart,
  onExpand,
  onCollapse,
  onLocate,
  children
}) {
  const collapsed = heightRatio <= 0.15;

  return (
    <div
      ref={containerRef}
      className={`mobile-container ${isDragging ? 'dragging' : ''}`}
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        height: `${heightRatio * 100}vh`,
        background: collapsed ? 'transparent' : '#eaf3fb',
        borderTop: collapsed ? 'none' : '2px solid #1976d2',
        boxShadow: collapsed ? 'none' : '0 -2px 10px rgba(0,0,0,0.1)',
        zIndex: 1000,
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
        transition: 'all 0.3s ease-in-out'
      }}
    >
      <div
        className="drag-handle"
        style={{
          height: '24px',
          background: 'linear-gradient(135deg, #1976d2, #42a5f5)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'grab',
          userSelect: 'none',
          position: 'relative'
        }}
        onMouseDown={onDragStart}
        onTouchStart={onDragStart}
      >
        <div style={{
          width: '40px',
          height: '4px',
          background: 'rgba(255,255,255,0.8)',
          borderRadius: '2px',
          position: 'relative'
        }}>
          <div style={{
            position: 'absolute',
            top: '-8px',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '12px',
            color: '#fff',
            fontWeight: '500',
            whiteSpace: 'nowrap'
          }}>
            {collapsed ? '上拉展开' : '拖拽调整'}
          </div>
          <div style={{
            position: 'absolute',
            top: '12px',
            left: '50%',
            transform: 'translateX(-50%)',
            fontSize: '10px',
            color: 'rgba(255,255,255,0.8)',
            whiteSpace: 'nowrap'
          }}>
            {Math.round(heightRatio * 100)}%
          </div>
        </div>

        {collapsed ? (
          <button
            onClick={onExpand}
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.2)',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '4px',
              color: '#fff',
              fontSize: '11px',
              padding: '2px 6px',
              cursor: 'pointer'
            }}
          >
            展开
          </button>
        ) : (
          <button
            onClick={onCollapse}
            style={{
              position: 'absolute',
              right: '12px',
              top: '50%',
              transform: 'translateY(-50%)',
              background: 'rgba(255,255,255,0.2)',
              border: '1px solid rgba(255,255,255,0.3)',
              borderRadius: '4px',
              color: '#fff',
              fontSize: '11px',
              padding: '2px 6px',
              cursor: 'pointer'
            }}
          >
            收缩
          </button>
        )}

        <button
          onClick={onLocate}
          style={{
            position: 'absolute',
            left: '12px',
            top: '50%',
            transform: 'translateY(-50%)',
            background: 'rgba(25, 118, 210, 0.8)',
            border: '1px solid rgba(25, 118, 210, 0.9)',
            borderRadius: '4px',
            color: '#fff',
            fontSize: '10px',
            padding: '4px 6px',
            cursor: 'pointer',
            fontWeight: 'bold'
          }}
        >
          定位
        </button>
      </div>

      {children}
    </div>
  );
}
